import { render } from "./HormoneRecord.vue?vue&type=template&id=6d345c1b&scoped=true"
import script from "./HormoneRecord.vue?vue&type=script&lang=js"
export * from "./HormoneRecord.vue?vue&type=script&lang=js"

import "./HormoneRecord.vue?vue&type=style&index=0&id=6d345c1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d345c1b"]])

export default __exports__